import React from 'react';

import UploadAttachments from '../../commonComponents/shared/UploadAttachments';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import AutocompleteInput from '../../commonComponents/util/AutocompleteInput';
import { formatReferenceOptions } from '../../../lib/utils';
import { formatDate, formatCurrency } from '../../../lib/utils';

export default class CreateApplication extends React.Component {

    
    isWedding(reasonId, applicationReasons) {
        const s = "wedding";

        for (let index = 0; index < applicationReasons.length; index++) {
            const element = applicationReasons[index];
            if (element.key == reasonId)
            {
               let containsWedding = element.value.toLowerCase().includes(s);
                if (containsWedding)
                    return true;
            }
        }
        return false;
    }

    render() {
        const { application, submitAttempted, tags, applicationSourceType, recipientReferences, isManualPayment, recipientPledges } = this.props;

        const applicantPledgeOptions = recipientPledges.map(
            (x) => {
              return {
                key: x.applicantPledgeId,
                value:
                  formatDate(x.pledgeDate) +
                  " - " +
                  formatCurrency(x.pledgeAmount),
              };
            }
          );

        return (
            <div>
                <h5 className="section-header">Application Info</h5>
                {!!this.props.permissions.private &&
                    <div className="private-application">
                        <div className="custom-check-container">
                            <input type="checkbox" id="private" className="custom-check"
                                value={application.isPrivate} name="isPrivate"
                                onChange={(e) => this.props.updateApplication(e.target.name, e.target.checked)} />
                            <label htmlFor="private">Private Application <span className="accent-text xs-text icon-right">This application will only be viewed by you.</span></label>
                        </div>
                    </div>}
                <div className="info-row">
                    <div className="column-quarter">
                        <ValidatedInput input={<Select clearable={true} tabIndex={410}
                            options={tags.applicationReasons} />}
                            label="Reason" name="reasonId" value={application.reasonId}
                            onChange={this.props.updateApplication}
                            required={!isManualPayment} showRequiredError={submitAttempted} 
                            
                            />
                    </div>
                    <div className="column-quarter">
                        <label className="input-label">Request Amount</label>
                        <CurrencyFormatInput name="requestAmount" value={application.requestAmount} tabIndex={420}
                            onChange={(e) => this.props.updateApplication(e.target.name, e.target.value)}
                            isIsraeli={this.props.payeeIsIsraeli} />

                    </div>
                    <div className="column-quarter">
                        <ValidatedInput input={<Select tabIndex={430}
                            options={tags.approvers} />}
                            label="Approver" name="approverId" value={application.approverId}
                            onChange={this.props.updateApplication}
                            required={true} showRequiredError={submitAttempted} />
                    </div>
                </div>
                {
                        this.isWedding(this.props.application.reasonId, tags.applicationReasons)
                        &&
                        <div className="info-row flex-center">
                            <div className="column-quarter">
                                <ValidatedInput 
                                input={<input type="date" max="9999-12-31"/>}
                                label="Wedding Date" name="reasonDate" value={application.reasonDate} tabIndex={432}
                                onChange={this.props.updateApplication}                         
                                required={false} showRequiredError={this.submitAttempted} />
                            </div>
                            <div className="column-quarter"> 
                                <ValidatedInput
                                    input={<input type="text" />}
                                    label="Wedding Hall"
                                    name="weddingHall"
                                    value={application.weddingHall}
                                    onChange={this.props.updateApplication}
                                />
                            </div>
                            <div className="column-quarter"> 
                                <ValidatedInput 
                                    input={<Select tabIndex={430} 
                                    options={[{ key: 'Boy', value: 'Boy'}, { key: 'Girl', value: 'Girl'}]} />}
                                    label="Side" 
                                    name="weddingSide" 
                                    value={application.weddingSide}
                                    onChange={this.props.updateApplication}
                                />
                            </div>
                        </div>
                    }
                <div className="info-row flex-center">
                    <RadioGroup
                        title="Source"
                        options={[
                            { key: 'new', value: 'Enter New' },
                            { key: 'reference', value: 'Choose Reference', disabled: !recipientReferences.length }
                        ]}
                        name="applicationSourceType" value={applicationSourceType}
                        onChange={this.props.toggleSourceType} />

                    {applicationSourceType === "reference"
                        ? <Select tabIndex={440}
                            options={recipientReferences.map(ref => ({ key: ref.referenceId, value: ref.displayName }))}
                            name="sourceId"
                            value={application.sourceId}
                            onChange={e => this.props.updateApplication(e.target.name, e.target.value)} />
                        : <AutocompleteInput tabIndex={440}
                            showList={true}
                            placeholder="Search references"
                            name="sourceId" value={application.sourceId}
                            options={formatReferenceOptions(tags.references
                                .filter(r => recipientReferences.map(ref => ref.referenceId).indexOf(r.referenceId) < 0))}
                            update={this.props.updateApplication}
                        />}
                </div>
                <div className="info-row flex-center">
                <div className="column-quarter">
                    <label className="input-label">Campaign Individual Category</label>
                    <Select tabIndex={450} clearable={true} 
                            options={tags.campaignIndivCategories.filter(c => c.active !== false)}
                            name="individualCategoryId"
                            value={application.individualCategoryId}
                            onChange={e => this.props.updateApplication(e.target.name, e.target.value)} />
                            </div>
                </div>
                {recipientPledges.length >= 1 && <div className="column-third">
                            <label className="input-label">Pledge</label>
                            <Select tabIndex={455} clearable={true} 
                                    options={applicantPledgeOptions}
                                    name="applicantPledgeId"
                                    value={application.applicantPledgeId}
                                    onChange={e => this.props.updateApplication(e.target.name, e.target.value)} />
                        </div>}
                <div className="info-row">
                    <div className="column-third">
                        <label className="input-label">Note</label>
                        <textarea value={application.note} tabIndex={460}
                            onChange={(e) => this.props.updateApplication('note', e.target.value)} />
                    </div>
                    <UploadAttachments files={application.attachments} name="attachments"
                        onChange={this.props.updateApplication} />
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/CreateApplication.jsx